export default "https://cdn-static.gokick.com/assets/31d35e8a0a5d253fd42fea745a10067c9b91f7ab/images/choco-chill.d2e5a3cb4eac031c8a1d2dbef046a05a.png";